import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

export default function Servizi() {
  const servizi = [
    {
      titolo: "Medicazioni",
      descrizione: [
        { nome: "Medicazioni semplici", prezzo: "20€" },
        { nome: "Medicazioni complesse", prezzo: "30€" },
        { nome: "Rimozione punti di sutura con medicazione", prezzo: "30€" }
      ]
    },
    {
      titolo: "Diagnostica",
      descrizione: [
        { nome: "Elettrocardiogramma (ECG) con refertazione a distanza", prezzo: "25€" },
        { nome: "Holter cardiaco 24/48 ore", prezzo: "80€" },
        { nome: "Holter pressorio 24 ore", prezzo: "50€" },
        { nome: "M.O.C. densitometria calcaneare bilaterale", prezzo: "25€" },
        { nome: "Ecografie infermieristiche", prezzo: "30€" }
      ]
    },
    {
      titolo: "Terapie e somministrazioni",
      descrizione: [
        { nome: "Infusioni venose senza attesa e con attesa", prezzo: "30€ - 50€" },
        { nome: "Somministrazioni endovenose con accesso venoso", prezzo: "20€" },
        { nome: "Iniezioni intramuscolari", prezzo: "10€" },
        { nome: "Iniezioni sottocutanee", prezzo: "10€" },
        { nome: "Somministrazioni vaccini (sotto prescrizione medica)", prezzo: "30€" }
      ]
    },
    {
      titolo: "Gestione dispositivi e cateteri",
      descrizione: [
        { nome: "Cateterismo vescicale senza e con fornitura di materiale", prezzo: "30€ - 50€" },
        { nome: "Cateterismo estemporaneo per residuo vescicale", prezzo: "30€" },
        { nome: "Lavaggio catetere vescicale e sostituzione sacca", prezzo: "20€" },
        { nome: "Gestione urostomia", prezzo: "30€" },
        { nome: "Gestione catetere venoso centrale, medicazione e/o lavaggio", prezzo: "25€" }
      ]
    },
    {
      titolo: "Prevenzione e screening",
      descrizione: [
        { nome: "Screening rapidi capillari per emoglobina, glicemia, colesterolo", prezzo: "da 8€ a 28€" },
        { nome: "Tampone salivare streptococco A beta emolitico", prezzo: "15€" }
      ]
    },
    {
      titolo: "Formazione ed educazione sanitaria",
      descrizione: [
        { nome: "Corsi di rianimazione cardio-polmonare BLS con utilizzo defibrillatore", prezzo: "60€" },
        { nome: "Educazione sanitaria: autosomministrazione insulina, istruzioni parenti", prezzo: "30€" }
      ]
    },
    {
      titolo: "Servizi domiciliari",
      descrizione: [
        { nome: "Clistere domiciliare", prezzo: "40€" },
        { nome: "Igiene personale domiciliare", prezzo: "20€/ora (minimo 1 ora)" }
      ]
    }
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={{ textAlign: "center", padding: "40px", fontFamily: "Arial, sans-serif" }}>
      <h1 style={{ marginBottom: "10px" }}>Servizi Disponibili</h1>
      <p>
        Presso il <strong>Medicajato Center</strong> puoi usufruire dei seguenti servizi:
      </p>

      <div style={{ maxWidth: "650px", margin: "0 auto", textAlign: "left" }}>
        {servizi.map((item, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #ddd",
              borderRadius: "12px",
              marginBottom: "12px",
              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              overflow: "hidden",
              transition: "all 0.3s ease-in-out"
            }}
          >
            <div
              onClick={() => toggle(index)}
              style={{
                cursor: "pointer",
                backgroundColor: "#f8f8f8",
                padding: "15px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <strong>{item.titolo}</strong>
              {openIndex === index ? <FaChevronUp size={16} /> : <FaChevronDown size={16} />}
            </div>

            {openIndex === index && (
              <ul
                style={{
                  listStyleType: "none",
                  margin: 0,
                  padding: "10px 20px 15px 20px",
                  backgroundColor: "#fff"
                }}
              >
                {item.descrizione.map((servizio, i) => (
                  <li
                    key={i}
                    style={{
                      padding: "8px 0",
                      display: "flex",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #eee"
                    }}
                  >
                    <span>• {servizio.nome}</span>
                    <span style={{ fontWeight: "bold", color: "#007bff" }}>
                      {servizio.prezzo}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
